import VideoChattingModal from './VideoChattingModal';
export default VideoChattingModal;
